// Kennisbank TOC: highlight active heading based on scroll position
function initKennisbankToc() {
    const toc = document.querySelector('nav[aria-label="Inhoudsopgave"]');
    if (!toc) return;

    const article = document.querySelector('.kennisbank-template article');
    if (!article) return;

    const headings = [...article.querySelectorAll('h2[id], h3[id]')];
    if (!headings.length) return;

    const tocLinks = [...toc.querySelectorAll('a[href^="#"]')];
    const OFFSET = 200; // sticky header + buffer

    function setActive(id) {
        tocLinks.forEach(link => {
            link.classList.toggle('toc-link--active', link.getAttribute('href') === `#${id}`);
        });
    }

    function updateActive() {
        let activeId = headings[0].id;
        for (const heading of headings) {
            if (heading.getBoundingClientRect().top <= OFFSET) {
                activeId = heading.id;
            }
        }
        setActive(activeId);
    }

    // Subscribe to Lenis scroll events if available, else fall back to native scroll
    if (window.lenis) {
        window.lenis.on('scroll', updateActive);
    } else {
        window.addEventListener('scroll', updateActive, { passive: true });
    }

    // Set active immediately on click — don't wait for scroll events to catch up
    tocLinks.forEach(link => {
        link.addEventListener('click', () => {
            setActive(link.getAttribute('href').slice(1));
        });
    });

    updateActive();
}

// Run immediately if DOM is ready, otherwise wait for it
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKennisbankToc);
} else {
    initKennisbankToc();
}
